import Vue from 'vue'
import Vuex from 'vuex'
import {
    getRequest,
    postRequest,
    putRequest,
    deleteRequest,
    patchRequest
} from '../components/utils/axiosApi'
import setting from "../plugins/setting";

const WorkSpaceName = setting.data.WorkSpaceAttrName

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        update_tag: 0,          // 订单平台渲染触发器
        _processesUpdateTag: 0, // 记录 craftProcesses 的更新

        //#################### 订单控制台页面相关属性 #####################//
        homeOrders: new Map(),  // 订单控制台的所有订单

        //#################### 版房控制台页面相关属性 #####################//
        stereoOrderMap: new Map(),  // 版房控制台订单 Map
        currentStereoOrder: null,   // (版房)当前正在处理的订单
        craftProcessMap: new Map(),          // 工艺流程的模版(数组)

        //#################### 生产控制台页面相关属性 #####################//
        proOrderMap: new Map(),

        //#################### 审核控制台页面相关属性 #####################//
        verifyOrderMap: new Map(),       // 审核控制台 订单列表

        //#################### 采购控制台页面相关属性 #####################//
        applyOrderMap: new Map(),       // 采购控制台 订单列表
        currentApplyOrder: {             // 当前处理的采购页面的订单
            the_id: '',
            order_base: {
                base_id: '',
            },
        },

        //#################### 生产工艺流程相关的属性 #####################//
        craftMap: new Map(),      // 工艺记录单对象[Map]容器
        currentCraft: {
            name: '',
        },
        CurrentGroupCraft: '',     // 当前小组工艺
        PlanNumHasChange: false,    // 工艺记录单的数据是否发生了改变
        ShowCraftCreateGroup: false, // 是否展现创建小组任务单
        CreateGroupBatchShow: false,

        GroupBatchDetailShow: false,  // 批次小组是否展示
        GroupBatchDetailTitle: '',    // 批次小组标题
        currentGroupBatch: '',

        //#################### 入库控制台相关的属性 #####################//
        inStoreOrderMap: new Map(),
        currentInStoreOrder: null,


        updateTagName: '_updateTag_', // 对比 updateTagName 来判断 对象是否发生了变化

        //#################### 配置属性 #####################//
        craftInfoMap: new Map(),    // 工艺信息容器，与 craftMap 不同
        craftInfoUpdateTag: 0,       // 记录 craftInfoMap 内容变动的标示

        produceFactories: [],   // 生产工厂信息
        produceGroups: [],      // 生产小组信息

        // 当前用户信息
        currentUserInfo: {
            id: '',           // 用户 ID
            date_joined: '', // 加入日期
            employee: null,   // 员工信息
            is_active: '',    // 是否在使用
            username: '',      // 员工姓名
        },
        workTableMap: new Map(),
        workTableUpdateTag: 0,

        // #############################################
        // 财务相关
        // #############################################

        // 小组工单
        groupCraftsMap: new Map(),
        groupCraftUpdateTag:0, // 标记刷新


        // #############################################
        // 产品开发需求管理
        // #############################################
        proRequirementMap: new Map(),
        proRequirementTag: 0,
    },
    mutations: {
        /**
         * 添加 groupCrafts
         */
        addGroupCrafts(state, groupCrafts){
            groupCrafts.forEach(groupCraft=>{
                state.groupCraftsMap.set(groupCraft.id, groupCraft)
            })
            state.groupCraftUpdateTag += 1
        },

        setGroupCrafts(state,groupCrafts){
            state.groupCraftsMap.clear()
            this.commit('addGroupCrafts', groupCrafts)
        },


        /**
         * 设置/重置需求文档
         * @param state
         * @param proRequirements
         */
        setProRequirements(state, proRequirements) {
            const map = state.proRequirementMap
            map.clear()
            this.commit('addProRequirements', proRequirements)
        },

        /**
         * 添加需求文档
         * @param state
         * @param proRequirements
         */
        addProRequirements(state, proRequirements) {
            const map = state.proRequirementMap
            proRequirements.forEach(item => {
                map.set(item.id, item)
            })
            state.proRequirementTag += 1
        },

        /**
         * 设置用户信息
         */
        setUserInfo(state, userInfo) {
            const fields = ['id', 'date_joined', 'employee', 'is_active', 'username']
            fields.forEach(fieldName => {
                state.currentUserInfo[fieldName] = userInfo[fieldName]
            })
        },

        setProduceGroups(state, produceGroups) {
            state.produceGroups = produceGroups
        },

        /**
         * 重新渲染所有与 Order 模块有关的视图
         */
        _renderOrderModule(state) {
            state.update_tag += 1
        },

        /**
         * 更新一个订单 [内部调用]
         *
         * 该更新订单方法仅供内部使用
         * 外部调用不会触发重新渲染
         * 可以使用 updateOrder 来触发渲染
         */
        _updateOrder(state, order) {
            // 所有需要更新 order 的 Map 容器
            const orderMaps = [
                state.homeOrders,
                state.proOrderMap,
                state.verifyOrderMap,
                state.inStoreOrderMap,
                state.applyOrderMap,
            ]

            orderMaps.forEach((orderMap) => {
                if (orderMap.has(order.id)) {
                    orderMap.set(order.id, order)
                }
            })

        },

        /**
         * 更新订单[供外部调用]
         * @param state
         * @param order 指定更新的订单
         */
        updateOrder(state, order) {
            this.commit('_updateOrder', order)
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        /**
         * 添加订单到指定 Map
         */
        _addOrders(state, {orders, orderMap}) {
            orders.forEach((order) => {
                this.commit('_updateOrder', order)  // 更新订单对象
                orderMap.set(order.id, order)  // 添加到 订单控制台的 Map 容器中
            })
        },

        //#################### 订单控制台页面相关操作 ######################//
        // 添加订单
        addHomeOrders(state, orders) {
            const orderMap = state.homeOrders
            this.commit('_addOrders', {orders, orderMap})
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        removeOrder(state, order){
            // 所有需要更新 order 的 Map 容器
            const orderMaps = [
                state.homeOrders,
                state.proOrderMap,
                state.verifyOrderMap,
                state.inStoreOrderMap,
                state.applyOrderMap,
            ]

            orderMaps.forEach((orderMap) => {
                if (orderMap.has(order.id)) {
                    orderMap.delete(order.id)
                }
            })
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        // 清空订单
        _clearHomeOrders(state) {
            state.homeOrders.clear()
        },

        // 清空订单并触发渲染
        clearHomeOrders(state) {
            this.commit('_clearHomeOrders')
            this.commit('_renderOrderModule') // 触发重新渲染

        },

        // 设置订单
        setHomeOrders(state, orders) {
            this.commit('_clearHomeOrders')
            this.commit('addHomeOrders', orders)
        },

        //#################### 审核控制台相关操作 ######################//
        // 添加订单
        addVerifyOrders(state, orders) {
            const orderMap = state.verifyOrderMap // 订单容器
            this.commit('_addOrders', {orders, orderMap})
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        // 清空订单 ｜ 不会触发渲染，外部调用请使用 clearVerifyOrders
        _clearVerifyOrders(state) {
            state.verifyOrderMap.clear()
        },

        // 清空订单 ｜ 会触发渲染
        clearVerifyOrders(state) {
            this.commit('_clearVerifyOrders')
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        // 设置订单
        setVerifyOrders(state, orders) {
            this.commit('_clearVerifyOrders')
            this.commit('addVerifyOrders', orders)
        },

        // 删除审核订单
        deleteVerifyOrder(state, order) {
            this.commit('_updateOrder', order)

            if (state.verifyOrderMap.has(order.id)) {
                state.verifyOrderMap.delete(order.id)
            }
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        //#################### 版房控制台相关操作 ######################//
        /**
         * 在原有数据上，添加多个订单到版房控制台
         */
        addStereoOrders(state, orders) {
            const orderMap = state.stereoOrderMap
            this.commit('_addOrders', {orders, orderMap})
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        /**
         * 设置多个订单到版房控制台
         * 会清空前面的数据
         */
        setStereoOrders(state, orders) {
            state.stereoOrderMap.clear()
            this.commit('addStereoOrders', orders)
        },

        /**
         * 设置(版房)当前正在处理的订单
         */
        setCurrentStereoOrder(state, order) {
            state.currentStereoOrder = order
        },

        /**
         * 添加(多个)工艺流程模版
         */
        addCraftProcesses(state, craftProcesses) {
            const craftProcessMap = state.craftProcessMap
            craftProcesses.forEach(craftProcess => {
                craftProcessMap.set(craftProcess.id, craftProcess)
            })

            state._processesUpdateTag += 1 // 触发渲染
        },


        /**
         * 移除一些(版房)订单
         *
         * @param state store 存储
         * @param orders {Array} 被移除的订单
         * @param update {Boolean} 是否更新被移除的订单
         */
        removeStereoOrders(state, {orders, update = false}) {
            orders.forEach(order => {
                // 如果指定了 update 为 true ，则移除这些订单之前，先进行更新
                if (update) {
                    this.commit('_updateOrder', order)
                }

                // 移除订单
                state.stereoOrderMap.delete(order.id)
            })

            // 触发渲染
            this.commit('_renderOrderModule')
        },

        //#################### 采购相关操作 ######################//
        /**
         * 添加多个采购订单到存储
         */
        addApplyOrders(state, orders) {
            const orderMap = state.applyOrderMap
            this.commit('_addOrders', {orders, orderMap})
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        /**
         * 设置多个采购订单到存储
         * 与 addApplyOrders 不同，这里会对数据进行清空，然后进行再添加
         */
        setApplyOrders(state, orders) {
            state.applyOrderMap.clear()
            this.commit('addApplyOrders', orders)
        },

        /**
         * 设置当前正在处理的采购 order
         */
        setCurrentApplyOrder(state, order) {
            state.currentApplyOrder = order
        },

        /**
         * 移除一些(采购)订单
         *
         * @param state store 存储
         * @param orders {Array} 被移除的订单
         * @param update {Boolean} 是否更新被移除的订单
         */
        removeApplyOrders(state, {orders, update = false}) {
            orders.forEach(order => {
                // 如果指定了 update 为 true ，则移除这些订单之前，先进行更新
                if (update) {
                    this.commit('_updateOrder', order)
                }

                // 移除订单
                state.applyOrderMap.delete(order.id)
            })

            // 触发渲染
            this.commit('_renderOrderModule')
        },

        //#################### 生产控制台相关操作 ######################//
        /**
         *添加订单
         */
        addProduceOrders(state, orders) {
            const orderMap = state.proOrderMap
            this.commit('_addOrders', {orders, orderMap})
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        /**
         * 清除所有的订单数据
         * 内部调用，不触发响应渲染
         */
        _clearProduceOrders(state) {
            state.proOrderMap.clear()
        },

        /**
         * [清除并重新]设置订单
         */
        setProduceOrders(state, orders) {
            this.commit('_clearProduceOrders')
            this.commit('addProduceOrders', orders)
        },

        //#################### 生产工艺相关操作 ######################//
        /**
         * 设置工厂小组信息
         */
        setProduceFactories(state, produceFactories) {
            state.produceFactories = produceFactories
        },

        // 生产控制台相关操作
        addCrafts(state, crafts) {
            crafts.forEach((craft) => {
                this.commit('_updateCraft', craft)
            })
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        /**
         * 清除工艺
         *
         * 如果指定了 `workSpace`， 则清除指定 `workSpace`中的所有工艺
         * 否则清除所有工艺
         */
        _clearCrafts(state, workSpace) {
            if (workSpace) {
                for (const craft of state.craftMap.values()) {
                    if (craft[WorkSpaceName] === workSpace) {
                        state.craftMap.delete(craft.id)
                    }
                }
            } else {
                state.craftMap.clear()
            }
        },

        /**
         * 更新一个工艺
         */
        _updateCraft(state, craft) {
            if (!craft[WorkSpaceName]) {
                // 如果 craft 没有设置 WorkSpaceAttrName 属性
                // 则向存储中找有没有相同 id 的 craft 对象[ WorkSpace一般不会变动 ]
                // 然后采用 缓存中 craft 的 WorkSpace
                if (state.craftMap.has(craft.id)) {
                    const oldCraft = state.craftMap.get(craft.id)
                    craft[WorkSpaceName] = oldCraft[WorkSpaceName]
                } else {
                    console.error(`向 state 中放置工艺单数据时，必须表明 工艺单的 ${WorkSpaceName} 属性`)
                }
            }
            setting.craftMethods.setupCraft(craft)
            state.craftMap.set(craft.id, craft)
            this.commit('_updateOrder', craft.order)
        },

        // 更新一个工艺并触发渲染
        updateCraft(state, craft) {
            this.commit('_updateCraft', craft)
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        // 更新当前工艺
        updateCurrentCraft(state, currentCraft) {
            // 更新 currentCraft ，crafts 中的 currentCraft 也需一起更新
            this.commit('_updateCraft', currentCraft)

            currentCraft.groupcraftrecord_set.forEach(groupCraftRecord => {
                if (state.CurrentGroupCraft && state.CurrentGroupCraft.id === groupCraftRecord.id) {
                    this.commit('setCurrentGroupCraft', groupCraftRecord)
                }
            })

            state.currentCraft = currentCraft

            this.commit('_renderOrderModule') // 触发重新渲染
        },

        /**
         * 更新一个工艺信息
         */
        setCraftInfo(state, craftInfo) {
            state.craftInfoMap.set(craftInfo.id, craftInfo)
            state.craftInfoUpdateTag += 1
        },

        setCurrentCraft(state, currentCraft) {
            state.currentCraft = currentCraft
            this.commit('updateCurrentCraft', currentCraft)
        },

        removeCraft(state, craft) {
            this.commit('_updateCraft', craft)
            state.craftMap.delete(craft.id)
            this.commit('_renderOrderModule')
        },

        // 为指定工作台设置指定工艺
        setCrafts(state, {workSpace, crafts}) {
            this.commit('_clearCrafts', workSpace)
            this.commit('addCrafts', crafts)
        },

        //#################### 入库控制台相关操作 #####################//
        addInStoreOrders(state, orders) {
            const orderMap = state.inStoreOrderMap
            this.commit('_addOrders', {orders, orderMap})
            this.commit('_renderOrderModule') // 触发重新渲染
        },

        _clearStoreOrders(state) {
            state.inStoreOrderMap.clear()
        },

        initInStoreOrders(state, orders) {
            this.commit('_clearStoreOrders')
            this.commit('addInStoreOrders', orders)
        },
        updateCurrentInStoreOrder(state, order) {
            state.currentInStoreOrder = order
            this.commit('updateOrder', order)
        },

        // CurrentGroupCraft 是 CurrentCraft 的 子信息
        setCurrentGroupCraft(state, GroupCraft) {
            state.CurrentGroupCraft = GroupCraft
            this.commit('_renderOrderModule')
        },
        setPlanNumHasChange(state, result) {
            state.PlanNumHasChange = result
        },
        setShowCraftCreateGroup(state, value) {
            state.ShowCraftCreateGroup = value
        },
        setGroupBatchDetailShow(state, value) {
            state.GroupBatchDetailShow = value
        },
        setGroupBatchDetailTitle(state, value) {
            state.GroupBatchDetailTitle = value
        },
        setCreateGroupBatchShow(state, value) {
            state.CreateGroupBatchShow = value
        },

        /**
         * 设置当前正在处理的(工艺记录单)小组批次
         */
        setCurrentGroupBatch(state, currentGroupBatch) {
            state.currentGroupBatch = currentGroupBatch
        },

        /**
         * 添加工艺信息到 CraftInfoMap
         * 如果有重复的，会被新 craftInfo 覆盖
         */
        addCraftInfos(state, craftInfos) {
            craftInfos.forEach(craftInfo => {
                state.craftInfoMap.set(craftInfo.id, craftInfo)
            })
            state.craftInfoUpdateTag += 1
        },

        addWorkTables(state, workTables) {
            workTables.forEach(workTable => {
                state.workTableMap.set(workTable.id, workTable)
            })
            state.workTableUpdateTag += 1
        },

        /* **************************** init methods (load some resource)******************************************** */
        /**
         * 加载小组信息
         */
        loadProduceGroups(state) {
            const url = '/order_platform/api/produce_groups/';
            if (state.produceGroups.length <= 0) {
                getRequest(url).then(response => {
                    this.commit("setProduceGroups", response.data)
                })
            }
        },

    },
    actions: {
        loadProduceGroups({commit},){
            commit("loadProduceGroups")
        },
    },
    getters: {
        CasCaderOptions(state){
            const options = new Map();
            for (let i = 0; i < state.produceGroups.length; i++) {
                const produceInfo = state.produceGroups[i];
                // 第一个小组信息，init
                if (!options.has(produceInfo.factory)) {
                    const factoryNode = {
                        value: produceInfo.factory,
                        label: produceInfo.factory_name,
                        children: [
                            {
                                value: produceInfo.id,
                                label: produceInfo.name,
                            }
                        ]
                    };

                    options.set(produceInfo.factory, factoryNode)
                }

                // 小组的工厂信息已经存在
                else {
                    const factoryInfo = options.get(produceInfo.factory);
                    factoryInfo.children.push({
                        value: produceInfo.id,
                        label: produceInfo.name,
                    })
                }

            }
            return Array.from(options.values())

        },

        /**
         * 获取小组分派单列表信息
         */
        groupCraftData(state){
            const groupCraftArray = Array.from(state.groupCraftsMap.values())
            const _tag = state.groupCraftUpdateTag
            return {groupCraftArray, _tag}
        },

        /**
         * 需求文档信息
         */
        ProRequirementData(state) {
            const proRequirements = Array.from(state.proRequirementMap.values())
            const _tag = state.proRequirementTag
            return {proRequirements, _tag}
        },

        /**
         * 返回一个工艺是否严格要求
         *
         * 严格要求是指 上报数量 与 通知数据必须一致
         * 在裁床之后的工艺都是严格要求
         */
        isStrictCraftRecord(state) {
            return (craftRecord) => {
                const craftrecord_set = craftRecord.order.craftrecord_set
                const currentStep = craftRecord.step

                // 裁剪工艺的 step
                // 裁剪工艺之后的 step 都是严格的
                // 如果没有裁床工艺
                // 则所有工艺都是严格要求
                let cuttingStep = 0
                for (let i = 0; i < craftrecord_set.length; i++) {
                    const _craftRecord = craftrecord_set[i]

                    // 判断一个工艺记录是不是裁剪工艺
                    if (_craftRecord.craft === 1) {
                        cuttingStep = _craftRecord.step
                    }
                }

                // 在裁床之前的工艺都是松散要求
                return currentStep > cuttingStep
            }
        },

        _getRoute(state) {
            return (key) => {
                if (state.currentUserInfo.employee) {
                    for (let i = 0; i < state.currentUserInfo.employee.power.length; i++) {
                        const powerRouter = state.currentUserInfo.employee.power[i]
                        if (powerRouter['key'] === key) {
                            return true
                        }
                    }
                }
                return false
            }
        },

        /**
         * 是否有进入淘宝数据(路由)的权限
         */
        taobaoRoute(state, getters) {
            const key = 'taobao'
            return getters._getRoute(key)
        },

        /**
         * 是否有进入标准文件(路由)的权限
         */
        isoFilesRoute(state, getters) {
            const key = 'iso'
            return getters._getRoute(key)
        },

        /**
         * 是否有进入内网后台的权限
         */
        adminRoute(state, getters) {
            const key = 'admin'
            return getters._getRoute(key)
        },

        /**
         * 是否有进入库存动销的权限
         */
        depoRoute(state, getters) {
            const key = 'depos'
            return getters._getRoute(key)
        },

        /**
         * 是否有进入下单管理的权限
         */
        orderRoute(state, getters) {
            const key = "orders"
            return getters._getRoute(key)
        },

        /**
         * 是否有进入商品库的权限
         */
        goodRoute(state, getters) {
            const key = "goods"
            return getters._getRoute(key)
        },

        orderPlatformRoute(state, getters) {
            const key = "order_platform"
            return getters._getRoute(key)
        },

        /**
         * 获取工艺信息
         */
        craftInfoData(state, getters) {
            const craftInfoArray = Array.from(state.craftInfoMap.values())
            const updateTag = state.craftInfoUpdateTag
            return {craftInfoArray, updateTag}
        },

        /**
         * 工艺模版信息
         */
        CraftProcessData(state, getters) {
            const CraftProcessArray = Array.from(state.craftProcessMap.values())
            const _processesUpdateTag = state._processesUpdateTag
            return {CraftProcessArray, _processesUpdateTag}
        },

        /**
         * 渲染包含器
         * 返回一个对象容器，经该容器返回的对象是响应式的
         */
        _orderModuleResult: (state) => (data) => {
            const _renderOrderTag = state.update_tag
            const ret = {
                _renderOrderTag: _renderOrderTag
            }
            for (let key in data) {
                ret[key] = data[key]
            }
            return ret
        },

        home_orders(state, getters) {
            const orders = Array.from(state.homeOrders.values())

            return getters._orderModuleResult({orders})
        },
        /**
         * 通过 WorkSpace 取出控制台相关的工艺单
         */
        craftsByWorkSpace: (state, getters) => (workSpace) => {
            const crafts_arr = Array.from(state.craftMap.values())
            const crafts = crafts_arr.filter(
                (craft) => {
                    return craft[WorkSpaceName] === workSpace
                }
            )

            return getters._orderModuleResult({crafts})
        },
        // currentCraft 是否可以修改
        currentCraftIsMdf(state, getters) {
            return setting.craftMethods.isCanChange(state.currentCraft)
        },

        // currentCraft 是否是草稿
        currentCraftIsDraft(state, getters) {
            return setting.craftMethods.isDraft(state.currentCraft)
        },

        // currentCraft 是否提交状态
        currentCraftIsSubmit(state, getters) {
            return setting.craftMethods.isSubmit(state.currentCraft)
        },

        currentCraftIsReverseVerify(state, getters) {
            return setting.craftMethods.isReverseVerify(state.currentCraft)
        },

        currentCraftIsVerify(state, getters) {
            return setting.craftMethods.isVerify(state.currentCraft)
        },

        //#################### 审核控制台相关 getters ######################//
        verifyOrderData(state, getters) {
            const orderList = Array.from(state.verifyOrderMap.values())

            return getters._orderModuleResult({orderList})

        },

        applyOrdersData(state, getters) {
            const orderList = Array.from(state.applyOrderMap.values())

            return getters._orderModuleResult({orderList})
        },

        //#################### 生产控制台相关 getters ######################//
        produceOrderData(state, getters) {
            const orderList = Array.from(state.proOrderMap.values())

            return getters._orderModuleResult({orderList})
        },

        //#################### 入库控制台相关 getters ######################//
        inStoreOrderData(state, getters) {
            const orderList = Array.from(state.inStoreOrderMap.values())

            return getters._orderModuleResult({orderList})
        },

        currentInStoreOrderData(state, getters) {
            let currentInStoreOrder = state.currentInStoreOrder

            const defaultOrder = {
                the_id: '',
            }

            // 对 currentInStoreOrder 进行装配
            function setupOrder(order) {
                order.ordersize_set.forEach((orderSize) => {
                    orderSize.sizeinstore_set.sort((sizeinstoreA, sizeinstoreB) => {
                        return sizeinstoreA.in_store_record.id - sizeinstoreB.in_store_record.id
                    })
                })
            }

            if (currentInStoreOrder) {
                setupOrder(currentInStoreOrder)
            } else {
                currentInStoreOrder = defaultOrder
            }
            return getters._orderModuleResult({currentInStoreOrder})
        },

        /**
         * 版房控制台订单数据
         * @return {orderList,_renderOrderTag}
         */
        stereoOrderData(state, getters) {
            const orderList = Array.from(state.stereoOrderMap.values())
            return getters._orderModuleResult({orderList})
        },

        // ###############  与配置有关的getters  ############### //
        workTableData(state) {
            const workTableArray = Array.from(state.workTableMap.values())
            return {
                workTableArray,
                _updateTag: state.workTableUpdateTag
            }

        },
    },
    modules: {},

})
